import React from "react"
import { Layout, Page } from "@shopify/polaris"
import {
  SHOW_LIMITED_REF_DB_SEARCH_BANNER,
  useFeatureFlag,
} from "hooks/useFeatureFlag"
import ReferenceDatabaseEmbedMolecule from "views/molecules/reference_database/ReferenceDatabaseEmbedMolecule"
import LimitedRefDbSearchBanner from "views/molecules/reference_database/LimitedRefDbSearchBanner"
import "stylesheets/components/ReferenceDatabase.scss"

const ReferenceDatabase = () => {
  const { isFeatureActive } = useFeatureFlag()

  return (
    <div className="referenceDatabasePage">
      <Page fullWidth>
        <Layout>
          <Layout.Section>
            {isFeatureActive(SHOW_LIMITED_REF_DB_SEARCH_BANNER) && (
              <LimitedRefDbSearchBanner />
            )}
            <div className="referenceDatabasePage__iframeWrapper">
              <ReferenceDatabaseEmbedMolecule />
            </div>
          </Layout.Section>
        </Layout>
      </Page>
    </div>
  )
}

export default ReferenceDatabase
